import type { FC } from 'react';
import type { ConnectedProps } from 'react-redux';

import { bindActionCreators } from '@reduxjs/toolkit';
import { Container } from 'components/template/container/container';
import { StatisticItem } from 'components/template/statistic-item/statistic-item';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { type AppState } from 'store';
import { getStatisticsThunk } from 'store/statistics/statistics.thunks';
import { vocabulary } from 'vocabulary/german';

import { usePermissions } from '../../../contexts/permissions.context';
import { PageHeader } from '../../template/page-header/page-header';

const mapStateToProps = (state: AppState) => ({
  statistics: state.statistics.statistics,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getStatisticsThunk,
    },
    dispatch,
  );

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const HomePage: FC<PropsFromRedux> = (props: PropsFromRedux) => {
  const matrix = usePermissions();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem('role');
    setIsAdmin(role === 'admin');
  }, []);

  useEffect(() => {
    props.getStatisticsThunk();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { statistics } = props;
  const otherProps = { permissions: matrix.permissions };

  return (
    <div className={'page-content'}>
      <PageHeader
        title="Home Page"
        btnText=""
        downloadReport={null}
        {...otherProps}
      />
      <Container>
        <div className={'statistic-wrapper'}>
          <StatisticItem
            title={vocabulary.labels.policiesAreas}
            link="/policy-areas"
            number={statistics!.policies}
          />
          <StatisticItem
            title={vocabulary.labels.agencies}
            link="/agencies"
            number={statistics!.agencies}
          />
          {isAdmin && (
            <>
              <StatisticItem
                title={vocabulary.labels.people}
                link="/people"
                number={statistics!.peoples}
              />
              <StatisticItem
                title={vocabulary.labels.priorities}
                link="/priorities"
                number={statistics!.priorities}
              />
            </>
          )}
          <StatisticItem
            title={vocabulary.labels.divisions}
            link="/divisions"
            number={statistics.divisions}
          />
        </div>
      </Container>
    </div>
  );
};

export default connector(HomePage);
